import '@magnetic/theme';
import { useClassNames } from '@magnetic/hooks';
import React, { forwardRef, memo } from 'react';
import { svgMap } from './svg-map.js';

const StatusIconWithRef = forwardRef(
  ({ className, status, variation = "none", ...rest }, ref) => {
    const classNames = useClassNames("mds-status-icon", className);
    const Component = svgMap[status][variation];
    return /* @__PURE__ */ React.createElement(Component, {
      ...rest,
      className: classNames,
      ref
    });
  }
);
const StatusIcon = memo(StatusIconWithRef);

export { StatusIcon };
//# sourceMappingURL=index.js.map
